import React from 'react'
import { Preview } from './preview'

export default () => {
  return <Preview />
}
